/**
 * @generated SignedSource<<8992270719a95b1a73d5091a240a2d61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MergeLabelsInput = {
  labelIds?: ReadonlyArray<string | null> | null;
  name?: string | null;
  color?: string | null;
  categoryId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type mergeLabelsMutation$variables = {
  input: MergeLabelsInput;
};
export type mergeLabelsMutation$data = {
  readonly mergeLabels: {
    readonly label: {
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly taskCount: number | null;
        readonly projectCount: number | null;
        readonly peopleCount: number | null;
        readonly category: {
          readonly id: string;
          readonly allowOnTasks: boolean | null;
          readonly allowOnProjects: boolean | null;
          readonly allowOnPeople: boolean | null;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"labelCategoryRow_labels">;
      } | null;
    } | null;
    readonly deletedLabelIds: ReadonlyArray<string | null> | null;
  } | null;
};
export type mergeLabelsMutation = {
  variables: mergeLabelsMutation$variables;
  response: mergeLabelsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "peopleCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "LabelCategory",
  "kind": "LinkedField",
  "name": "category",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowOnTasks",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowOnProjects",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowOnPeople",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedLabelIds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "mergeLabelsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MergeLabelsPayload",
        "kind": "LinkedField",
        "name": "mergeLabels",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LabelTypeEdge",
            "kind": "LinkedField",
            "name": "label",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Label",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "labelCategoryRow_labels"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mergeLabelsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MergeLabelsPayload",
        "kind": "LinkedField",
        "name": "mergeLabels",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LabelTypeEdge",
            "kind": "LinkedField",
            "name": "label",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Label",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "70c27b051ae66f9377298acfdbbd598f",
    "id": null,
    "metadata": {},
    "name": "mergeLabelsMutation",
    "operationKind": "mutation",
    "text": "mutation mergeLabelsMutation(\n  $input: MergeLabelsInput!\n) {\n  mergeLabels(input: $input) {\n    label {\n      node {\n        id\n        name\n        taskCount\n        projectCount\n        peopleCount\n        category {\n          id\n          allowOnTasks\n          allowOnProjects\n          allowOnPeople\n        }\n        ...labelCategoryRow_labels\n      }\n    }\n    deletedLabelIds\n  }\n}\n\nfragment labelCategoryRow_labels on Label {\n  id\n  name\n  taskCount\n  projectCount\n  peopleCount\n  ...labelRow_label\n}\n\nfragment labelRow_label on Label {\n  id\n  name\n  color\n  taskCount\n  projectCount\n  peopleCount\n}\n"
  }
};
})();

(node as any).hash = "e9c2b2f3870a56dd80946b0d20f985f8";

export default node;
